import { StyleSheet } from 'react-native'
import { whiteBackgroundColor } from '../../../../theme/colors'
import { inputStyle } from '../../../../theme/inputs'

export const formStyles = StyleSheet.create({
  container: {
    padding: 10,
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },

  label: {
    ...inputStyle.label,
    ...inputStyle.labelFloating,
    backgroundColor: 'white',
  },

  ckeckContainer: {
    marginVertical: 10,
    flexDirection: 'row',
    borderRadius: 5,
    borderWidth: 0.6,
    overflow: 'hidden',
  },
  leftColumn: {
    flex: 1,
    backgroundColor: whiteBackgroundColor,
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  rigthColumn: {
    flex: 3,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignItems: 'center',
  },
})
